<div class="row">
    <div class="col-12">
      <div class="content-header">Opening Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md">
                  <form [formGroup]="OpeningForm">
                    <fieldset class="form-group mt-3">
                      <label>Title <span class="required_field">*</span></label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="title"
                        [(ngModel)]="model.title"
                        id="title"
                        placeholder="Enter title"
                        required
                      />
                      <div
                        *ngIf="
                          rf.title.touched &&
                          (rf.title.invalid || rf.title.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> title is
                        required
                      </div>
                    </fieldset>
                    <fieldset class="form-group">
                      <label>Website</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="website"
                        [(ngModel)]="model.website"
                        id="website"
                        placeholder="Enter website"
                        required
                      />
                    </fieldset>
                    <fieldset class="form-group">
                      <label>Phone <span class="required_field">*</span></label>
                      <input
                        placeholder="e.g. 1234-567-890"
                        mask="0000-000-000" minlength="10"
                        type="text"
                        class="form-control"
                        formControlName="contact_phone"
                        [(ngModel)]="model.contact_phone"
                        id="contact_phone"                        
                      />
                    </fieldset>
                    <fieldset class="form-group">
                      <label>Employment Type <span class="required_field">*</span></label>
                      <ng-select
                          [items]="emp_type_list"
                          bindLabel="displayname"
                          bindValue="_id"
                          placeholder="Select Type"
                          [(ngModel)]="selected_type"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getEmpTypeId($event)"
                      >
                      </ng-select>
                   
                    </fieldset>
                    <fieldset class="form-group">
                      <label>Location</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="location"
                        [(ngModel)]="model.location"
                        id="location"
                        placeholder="Enter location"
                        required
                      />
                   
                    </fieldset>
                    <!-- <fieldset class="form-group">
                      <label>Applied For</label>
                      <ng-select
                          [items]="users_list"
                          bindLabel="name"
                          bindValue="_id"
                          placeholder="Select User"
                          [multiple]="true"
                          [(ngModel)]="selected_user"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getUserId($event)"
                      >
                      </ng-select>
                    </fieldset> -->
                    <fieldset class="form-group">
                      <label>Salary</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="salary"
                        [(ngModel)]="model.salary"
                        id="salary"
                        placeholder="Enter salary"
                        required
                      />
                   
                    </fieldset>
                    <fieldset class="form-group">
                      <label>Responsibilities <span class="required_field">*</span></label>
                      <textarea
                        formControlName="responsibilities"
                        [(ngModel)]="model.responsibilities"
                        id="hidden-label-form-6"
                        rows="3"
                        class="form-control"
                        name="comment2"
                        placeholder="Enter responsibilities"
                        required
                        #responsibilities
                      ></textarea>
                      
                    </fieldset>
                    <fieldset class="form-group">
                      <label>notes</label>
                      <textarea
                        formControlName="notes"
                        [(ngModel)]="model.notes"
                        id="hidden-label-form-6"
                        rows="4"
                        class="form-control"
                        name="comment2"
                        placeholder="Enter notes"
                        required
                        #notes
                      ></textarea>
                   
                    </fieldset>
                  </form>
                </div>
                <div class="col-md">
                  <form [formGroup]="OpeningForm">
                    <!-- <fieldset class="form-group">
                        <label>Job Id</label>
                        <ng-select
                            [items]="job_list"
                            bindLabel="name"
                            bindValue="_id"
                            placeholder="Select Job"
                            [(ngModel)]="selected_job"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="getJobId($event)"
                        >
                        </ng-select>
                     
                      </fieldset> -->
                      <fieldset class="form-group mt-1">
                        <label>company <span class="required_field">*</span></label> <button class="btn btn-outline-primary" id="btn-new" >
                          <a routerLink="/business/add" target="_blank"> + </a>
                        </button>
                        <ng-select
                            [items]="company_list"
                            bindLabel="name"
                            bindValue="_id"
                            placeholder="Select Company"
                            [(ngModel)]="selected_company"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="getCompanyId($event)"
                        >
                        </ng-select>
                      </fieldset>
                      <fieldset class="form-group">
                        <label>Email <span class="required_field">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="contact_email"
                          [(ngModel)]="model.contact_email"
                          id="contact_email"
                          placeholder="Enter contact email"
                          
                        />
                      </fieldset>
                      <fieldset class="form-group">
                        <label>Category</label>
                        <ng-select
                            [items]="category_list"
                            bindLabel="displayname"
                            bindValue="_id"
                            placeholder="Select Type"
                            [(ngModel)]="selected_category"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="getCategoryId($event)"
                        >
                        </ng-select>
                     
                      </fieldset>
                      
                      <fieldset class="form-group">
                        <label>Deadline</label>
                        <input
                          type="date"
                          class="form-control"
                          [(ngModel)]="model.deadline"
                          [ngModel]="model.deadline | date: 'yyyy-MM-dd'" [disabled]="false"
                          [ngModelOptions]="{standalone: true}"
                          id="deadline"
                          placeholder="Enter deadline"
                          required
                        />
                     
                      </fieldset>
                      <fieldset class="form-group">
                        <label class="mb-4">Experience</label>
                        <nouislider [config]="someTimeConfig"  [(ngModel)]="experince_Value" [ngModelOptions]="{standalone: true}" >
                        </nouislider>
                      </fieldset>
                      <!-- <fieldset class="form-group" id="ddd">
                        <label>Short Listed</label>
                        <ng-select
                            [items]="users_list"
                            bindLabel="name"
                            bindValue="_id"
                            placeholder="Select User"
                            [multiple]="true"
                            [(ngModel)]="selected_shortlist_user"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="getShortUserId($event)"
                        >
                        </ng-select>
                      </fieldset> -->
                      <fieldset class="form-group">
                        <label>description</label>
                        <textarea
                          formControlName="description"
                          [(ngModel)]="model.description"
                          id="hidden-label-form-6"
                          rows="3"
                          class="form-control"
                          name="comment2"
                          placeholder="Enter description"
                          required
                          #description
                        ></textarea>
                      </fieldset>
                    <fieldset class="form-group">
                      <label>admin notes</label>
                      <textarea
                        formControlName="admin_notes"
                        [(ngModel)]="model.admin_notes"
                        id="hidden-label-form-6"
                        rows="6"
                        class="form-control"
                        name="comment2"
                        placeholder="Enter admin notes"
                        required
                        #admin_notes
                      ></textarea>
                     
                    </fieldset>
                
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="submit()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                        (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  